Whether the person is still working at the organization, if known.
